import { render } from "./MissionSection.vue?vue&type=template&id=588d6110&scoped=true"
const script = {}

import "./MissionSection.vue?vue&type=style&index=0&id=588d6110&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-588d6110"]])

export default __exports__